export class PlanNumSearchParamsModel {
  constructor(
    public orderCode = '',
    public catalogId = '',
    public progressWorkNum = '',
    public mediumType = '',
    public featureCode = '',
    public buyerCode = '',
    public folio = '',
    public classCode = '',
    public middleClassCode = '',
    public boundaryNum = '',
    public boundaryNumDetail = '',
    public checkFlag = false,
  ) { }

  private readonly validations = [
    {
      validate: () => !!this.orderCode,
      code: 'W0001',
      message: '受注コード'
    },
    {
      validate: () => !!this.catalogId,
      code: 'W0001',
      message: '企画回'
    },
    {
      validate: () => !!this.mediumType,
      code: 'W0001',
      message: '媒体区分'
    },
  ];

  public validate() {
    const error = this.validations.find(v => !v.validate());
    if (!error) {
      return null;
    }

    return error;
  }

  public copy() {
    return new PlanNumSearchParamsModel(
      this.orderCode,
      this.catalogId,
      this.progressWorkNum,
      this.mediumType,
      this.featureCode,
      this.buyerCode,
      this.folio,
      this.classCode,
      this.middleClassCode,
      this.boundaryNum,
      this.boundaryNumDetail,
      this.checkFlag,
    );
  }
}